import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const FailedAccessCodeAttempt = ApplicationRecord.extend({
  static: {
    jsonapiType: 'failed_access_code_attempts',
  },
  attrs: {
    createdAt: attr(),
    email: attr(),
    grade: attr(),
    phone: attr(),
    schoolId: attr(),
    status: attr(),
    studentFirstName: attr(),
    studentLastName: attr(),
    updatedAt: attr(),
    school: belongsTo(),
  },
});

export default FailedAccessCodeAttempt;
